// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"r_6","subcategoryColumn":"r_7","articleLink":"r_8","articleCoverImage":"r_9","articleTitle":"r_bb","articleMetaDescription":"r_bH"};